import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Container } from '@mui/material';
import { RobotoFont, AlumniSansFont } from '../../styles/fonts';
import LocalizedLink from '../Link/localized-link';

export const MainWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#212223',

  '& .contact-text': {
    color: 'white',
    fontWeight: 300,
    lineHeight: '20px',
    fontSize: '16px',
    [theme.breakpoints.down('md768')]: {
      lineHeight: '20px',
      fontSize: '16px',
    },
  },
}));

export const BottomWrapper = styled(Box)(({ theme }) => ({
  fontFamily: RobotoFont.style.fontFamily,
  backgroundColor: '#1A1B1B',
  color: theme.palette.background.default,
  fontWeight: 400,
}));

export const NavLink = styled(LocalizedLink)({
  fontFamily: RobotoFont.style.fontFamily,
  fontSize: '16px',
  textTransform: 'uppercase',
  marginLeft: '10px',
  fontWeight: 400,
  letterSpacing: '-1px',
  transform: 'scaleX(0.75)',
});

export const FooterContainer = styled(Container)({
  maxWidth: '1440px',
  width: '100%',
  padding: '0 75px 0 100px',
  margin: '0',
  '@media only screen and (max-width: 768px)': {
    padding: '0 20px !important',
  },
});

export const CopyRightContainer = styled(Container)({
  maxWidth: '85vw',
  width: '100%',
  padding: '0 100px',
  margin: '0',
  '@media only screen and (max-width: 768px)': {
    padding: '0 20px !important',
  },
});

export const CopyRightText = styled('div')({
  fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
  letterSpacing: '-.75px',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 400,
  margin: '8px 0',
  color: '#D8D8D8',
  '@media only screen and (max-width: 768px)': {
    fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
    letterSpacing: '0px',
    color: '#808080',
    margin: '0',
  },
});

export const CopyRightTextPrivacy = styled('div')({
  fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
  letterSpacing: '-.75px',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 400,
  margin: '8px 0',
  color: '#D8D8D8',
  maxWidth: '205px',
  textDecoration: 'underline',
  '@media only screen and (max-width: 768px)': {
    fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
    letterSpacing: '0px',
    color: '#808080',
    margin: '0',
  },
});
